import { Component, OnInit } from '@angular/core';
// import { PopupService } from '@ng-bootstrap/ng-bootstrap/util/popup';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PopupAreaCoverageComponent } from 'src/app/popup/calculations/area-coverage/area-coverage.component';
import { PopupPerformanceAnalysisComponent } from 'src/app/popup/calculations/performance-analysis/performance-analysis.component';
import { PopupPerformanceCalculationComponent } from 'src/app/popup/calculations/performance-calculation/performance-calculation.component';
import { CalculationsControlService } from 'src/app/services/calculations-control.service';
import { HeaderControlService } from 'src/app/services/header-control.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { PointsService } from 'src/app/services/points.service';

@Component({
  selector: 'app-calculation-control',
  templateUrl: './calculation-control.component.html',
  styleUrls: ['./calculation-control.component.scss'],
  standalone: false 
})
export class CalculationControlComponent implements OnInit {
  active: boolean = false;

  constructor(
    public calculationsService: CalculationsControlService,
    private pointsService: PointsService,
    private headerController: HeaderControlService,
    private modalService: ModalControlService,
    private popupService: BsModalService
  ) {}

  ngOnInit(): void {}

  calculationsTrigger(): void {
    this.active = !this.active;
  }

  areaCoverageTrigger(): void {
    if (this.pointsService.getSelectedFeatures().length >= 1) {
      let navaidsCounter = 0;
      this.pointsService.getSelectedFeatures().forEach((element) => {
        if (element.getProperties().featureType == 0) {
          navaidsCounter++;
        }
      });
      if (navaidsCounter >= 1) {
        const bsModalRef : BsModalRef = this.popupService.show(PopupAreaCoverageComponent);
      } else {
        this.modalService.showMesssageModal(
          'Warning',
          'Please select at least 1 NavAids'
        );
      }
    } else {
      this.modalService.showMesssageModal(
        'Warning',
        'Please select at least 1 NavAids'
      );
    }
  }

  areaPerformanceTrigger(): void {
    if (this.pointsService.getSelectedFeatures().length >= 2) {
      let navaidsCounter = 0;
      this.pointsService.getSelectedFeatures().forEach((element) => {
        if (element.getProperties().featureType == 0) {
          navaidsCounter++;
        }
      });
      if (navaidsCounter >= 2) {
        const bsModalRef : BsModalRef = this.popupService.show(PopupPerformanceCalculationComponent);
      } else {
        this.modalService.showMesssageModal(
          'Warning',
          'Please select at least 2 NavAids'
        );
      }
    } else {
      this.modalService.showMesssageModal(
        'Warning',
        'Please select at least 2 NavAids'
      );
    }
  }

  procedureAnalysisTrigger(): void {
    if (this.pointsService.getSelectedFeatures().length >= 3) {
      let navaidsCounter = 0;
      let proceduresCounter = 0;
      this.pointsService.getSelectedFeatures().forEach((element) => {
        if (element.getProperties().featureType == 0) {
          //navaid
          navaidsCounter++;
        } else if (element.getProperties().featureType == 2) {
          proceduresCounter++;
        } //procedure
      });
      if (navaidsCounter >= 2 && proceduresCounter == 1){
        const bsModalRef : BsModalRef = this.popupService.show(PopupPerformanceAnalysisComponent);
      }
      else {
        this.modalService.showMesssageModal(
          'Warning',
          'Please select at least 2 NavAids and only 1 Procedure'
        );
      }
    } else {
      this.modalService.showMesssageModal(
        'Warning',
        'Please select at least 2 NavAids and only 1 Procedure'
      );
    }
  }
}
